<template>
	<footer class="footer">
		<div class="has-text-centered footer-text">
			copyright 2020
			<span class='bar'>|</span>
			all rights reserved
			<span class='bar'>|</span>
			<span 
				id='footer-link' 
				@mouseenter="footerAnimation.show()"
				@mouseleave="footerAnimation.hide()">
					<a :href="footerLinkUrl">
						{{ footerLinkText }}
					</a>
			</span>
		</div>
	</footer>
</template>


<script>
	import { mapState } from 'vuex';
	import { footerAnimation } from '../js/scroll.js';
	export default {
		mounted() {
			this.footerAnimation = footerAnimation();
		},
		computed: {
			...mapState(['width']),
			footerLinkText() {
				return window.location.href.includes('norththird') ? 'north third' :  'againwewander'
			},
			footerLinkUrl() {
				return window.location.href.includes('norththird') ? 'https://norththird.io' : 'https://againwewander.com'
			}
		},
		data() {
			return {
				footerAnimation: null,
			}
		},
	}
</script>